import React from 'react';
export default (function () {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "4",
    viewBox: "0 0 8 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 2L4 6 8 2z",
    transform: "translate(0 -2)"
  }));
});